import React from "react";

const PublicatiiPage = () => {
  const publicatii = [
    {
      data: "12.05.2017",
      tip: "Material didactic",
      nume: "Personajul literar",
      autor: "China Maria",
      fisier: "caracterizarea-personajelor_liceu.pdf",
    },
    {
      data: "22.03.2017",
      tip: "Material Didactic",
      nume: "Lecturi obligatorii",
      autor: "China Maria",
      fisier: "lecturiobligatorii--1-.pdf",
    },
    {
      data: "25.05.2016",
      tip: "Video",
      nume: "Bullying",
      autor: "Koncz Maria",
      fisier: "11.mp4",
    },
    {
      data: "28.04.2105",
      tip: "Articol",
      nume: "Universul verde",
      autor: "Covaci Georgina",
      fisier: "gine-2.pdf",
    },
    {
      data: "28.04.2015",
      tip: "Articol",
      nume: "Activitati preventiv-educativ",
      autor: "Covaci Georgiana",
      fisier: "gina-1.pdf",
    },
    {
      data: "10.04.2015",
      tip: "Material didactic",
      nume: "Ansamblari prin pene",
      autor: "Pop Delia Cornelia",
      fisier: "fise-de-lucru.pdf",
    },
    {
      data: "10.02.2015",
      tip: "Articol",
      nume: "Ferma didactica",
      autor: "Rus Anca Crina",
      fisier: "anca-site-2.pdf",
    },
    {
      data: "8.12.2014",
      tip: "Articol",
      nume: "Cercul pedagogic al Directorilor",
      autor: "Rus Anca Crina",
      fisier: "anca-site-5.pdf",
    },
    {
      data: "18.11.2014",
      tip: "Material didactic",
      nume: "Fisa de lucru clasa a VI-a",
      autor: "China Maria",
      fisier: "fisa de lucru 6-10_clasa a VI-a.pdf",
    },
    {
      data: "18.11.2014",
      tip: "Lectura",
      nume: "Mistere de pe Luna",
      autor: "Pop Delia Cornelia",
      fisier: "Astrologie-3.pdf",
    },
    {
      data: "2.11.2014",
      tip: "Articol",
      nume: "Zilele liceului",
      autor: "Rus Anca Crina",
      fisier: "anca-11.pdf",
    },
    {
      data: "2.11.2014",
      tip: "Articol",
      nume: "Simpozion - Elogiu griului strabun",
      autor: "Covaci Georgiana",
      fisier: "gina3.pdf",
    },
    {
      data: "28.10.2014",
      tip: "Articol",
      nume: "Toamna in suflet",
      autor: "Rus Anca Crina",
      fisier: "anca-site-3.pdf",
    },
    {
      data: "14.10.2014",
      tip: "Material didactic",
      nume: "Fisa de lucru - clasa a VI-a",
      autor: "China Maria",
      fisier: "Fisa de lucru 1-5_clasa a VI-a.pdf",
    },
    {
      data: "7.10.2014",
      tip: "Articol",
      nume: "Euro Voce Maramuresului la Ulmeni",
      autor: "Rus Anca Crina",
      fisier: "anca-site-4.pdf",
    },
    {
      data: "20.09.2014",
      tip: "Material didactic",
      nume: "Ansamblari demontabile",
      autor: "Pop Delia Cornelia",
      fisier: "PREZENTARE-PP-INSPECŢIE.ppsx",
    },
    {
      data: "13.05.2014",
      tip: "Lectura",
      nume: "Fenomene ciudate",
      autor: "Pop Delia Cornelia",
      fisier: "Astrologie-4.pdf",
    },
    {
      data: "10.12.2013",
      tip: "Soft educational",
      nume: "Saptamana Patimilor",
      autor: "Botis Sorina",
      fisier: "Saptamana-Patimilor....ppsx",
    },
    {
      data: "15.10.2013",
      tip: "Lectura",
      nume: "Eclipsa de Soare",
      autor: "Pop Delia Cornelia",
      fisier: "ASTRONOMIE-2.pdf",
    },
    {
      data: "2.12.2012",
      tip: "Soft educational",
      nume: "Rugaciunea Domneasca",
      autor: "Botis Sorina Mihaela",
      fisier: "Rugaciunea-Domneasca.ppt",
    },
    {
      data: "12.10.2012",
      tip: "Articol",
      nume: "Excursia - Gradina botanica ”Vasile Fati”",
      autor: "Rus Anca Crina",
      fisier: "articol-rus-site.pdf",
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <main className="max-w-7xl mx-auto px-4 py-8">
        <table className="table-auto w-full bg-white border border-gray-200">
          <thead>
            <tr className="bg-gray-100 text-gray-700 uppercase text-xs sm:text-sm leading-normal">
              <th className="py-3 px-2 sm:px-6 text-left">Data</th>
              <th className="py-3 px-2 sm:px-6 text-left">Tip Publicație</th>
              <th className="py-3 px-2 sm:px-6 text-left">Nume</th>
              <th className="py-3 px-2 sm:px-6 text-left">Autor</th>
            </tr>
          </thead>
          <tbody className="text-gray-600 text-xs sm:text-sm font-light">
            {publicatii.map((publicatie, index) => (
              <tr key={index} className="border-b border-gray-200">
                <td className="py-3 px-2 sm:px-6">{publicatie.data}</td>
                <td className="py-3 px-2 sm:px-6">{publicatie.tip}</td>
                <td className="py-3 px-2 sm:px-6">
                  <a
                    href={`/documente/publicatii/${publicatie.fisier}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-500 hover:underline"
                  >
                    {publicatie.nume}
                  </a>
                </td>
                <td className="py-3 px-2 sm:px-6">{publicatie.autor}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </main>
    </div>
  );
};

export default PublicatiiPage;
